import React from "react";

export default function SectionThree() {
  return (
    <>
      <div className="bg-primary-color relative  flex items-center p-5 md:justify-end text-white w-full  md:w-11/12 h-full">
        <img
          src={require("../../assets/About/AboutS3.png")}
          className="w-[30%] hidden md:block  absolute -left-[10%]"
          alt=""
        />
        <div className="w-full md:w-[70%]">

          <h3>H2A Medical Solutions</h3>
          <h5>Your Trusted Partner in Healthcare</h5>

          <p className="w-full md:w-4/5 font-light leading-relaxed">
            H2A Medical Solutions has earned a strong reputation as a trusted medical supplier, providing healthcare institutions across Egypt with reliable, high-quality diagnostic technologies.
            <br /><br />
            H2A is committed to delivering not only advanced medical equipment but also comprehensive support services that ensure long-term performance and satisfaction. Healthcare providers rely on H2A for its integrity, professionalism, and consistent dedication to excellence.
            <br /><br />
            By offering dependable solutions and fostering lasting partnerships, H2A plays a vital role in helping medical professionals build patient confidence and deliver superior care.

          </p>
        </div>
      </div>
    </>
  );
}
